import styles from './SaveSearch.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { Button, HeartIcon, ErrorIcon } from 'seek-style-guide/react';
import { save, states } from 'store/saveSearch/saveSearch';
import ExternalLink from 'ExternalLink/ExternalLink';

const { SAVED, ERROR, EXCEEDED, SAVING, UNSAVED } = states;

const mapStateToProps = ({ search, saveSearch, results }) => ({
  query: search.query,
  location: results.location,
  title: saveSearch.title,
  status: saveSearch.status
});

const mapDispatchToProps = dispatch => ({
  saveSearchHandler: ({ query, location }) => {
    dispatch(save({ query, location }));
  }
});

@connect(mapStateToProps, mapDispatchToProps)
class SaveSearch extends Component {

  static propTypes = {
    query: PropTypes.object.isRequired,
    location: PropTypes.object,
    saveSearchHandler: PropTypes.func.isRequired,
    title: PropTypes.string,
    status: PropTypes.string.isRequired
  };

  static defaultProps = {
    location: null,
    title: ''
  };

  getHeading(status) {
    switch (status) {
      case SAVED:
        return 'Your search has been saved';

      case EXCEEDED:
        return 'Unable to save this search';

      case ERROR:
        return 'Search not saved';

      default:
        return '';
    }
  }

  getText(status) {
    const { title } = this.props;

    switch (status) {
      case SAVED:
        return (
          <span>
            {'Search saved as '}
            <span className={styles.title} data-automation="saveSearchTitle">{title}</span>
            {'. '}
            <ExternalLink
              className={styles.edit}
              href="/myactivity#favourite">
              Manage saved searches
            </ExternalLink>
            {' via the account menu.'}
          </span>
        );

      case EXCEEDED:
        return (
          <span>
            {'You can save up to 25 searches. Delete from your list of '}
            <ExternalLink
              className={styles.edit}
              href="/myactivity#favourite">
              Saved searches
            </ExternalLink>
            {' before saving this one.'}
          </span>
        );

      case ERROR:
        return 'There\'s something wrong on our end. Try again in a little while';

      default:
        return '';
    }
  }

  renderMessage(status) {
    return (
      <div className={`${styles.message} ${styles[`message_${status.toLowerCase()}`]}`} data-automation={`saveSearch-${status.toLowerCase()}`}>
        {
          status === SAVED ?
            <HeartIcon filled={true} className={styles.messageIcon} svgClassName={styles.messageIconSvg} /> :
            <ErrorIcon className={styles.messageIcon} svgClassName={styles.messageIconSvg} />
        }
        <div className={styles.textContainer}>
          <p>{ this.getHeading(status) }</p>
          <p className={styles.description}>
            { this.getText(status) }
          </p>
        </div>
      </div>
    );
  }

  renderButton() {
    const { query, location, saveSearchHandler, status } = this.props;
    const saveHandler = () => saveSearchHandler({ query, location });

    const isSaving = status === SAVING;

    return (
      <Button
        color="blue"
        className={styles.saveButton}
        loading={isSaving}
        onClick={saveHandler}
        data-automation="saveSearchButton">
        { !isSaving && <HeartIcon svgClassName={styles.saveIconSvg} /> }
        { isSaving ? 'Saving' : 'Save search' }
      </Button>
    );
  }

  render() {
    const { status } = this.props;

    return (
      <div className={styles.root}>
        {
          status === UNSAVED || status === SAVING ?
            this.renderButton() :
            this.renderMessage(status)
        }
      </div>
    );
  }
}

export default SaveSearch;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanel/components/SaveSearch/SaveSearch.js
 **/